import { h } from 'preact';
import { useEffect, useState } from 'preact/hooks';
import { connect } from '../../hoc';

function SeekSprite({ ongoingSeek, width, seekThumbnail }) {
  const [thumbnailStyle, setThumbnailStyle] = useState({});

  useEffect(() => {
    const scale = width / seekThumbnail.width;
    const translate = (0.5 - (1 / (2 * scale))) * 100;

    setThumbnailStyle({
      ...{
        zIndex: -1,
        display: ongoingSeek ? 'block' : 'none',
        position: 'absolute',
        background: 'transparent',
        backgroundSize: 'cover',
        backgroundPosition: `-${seekThumbnail?.x || 0}px -${seekThumbnail?.y || 0}px`,
        transform: `scale(${scale}) translateX(${translate}%) translateY(${translate}%)`,
        width: seekThumbnail.width,
        height: seekThumbnail.height
      },
      ...seekThumbnail?.url && { background: `url("${seekThumbnail?.url}") no-repeat` }
    });
  }, [seekThumbnail.x, seekThumbnail.y, seekThumbnail.url, seekThumbnail.width, ongoingSeek]);

  return (
    <div style={thumbnailStyle} />
  );
}

const selector = (store) => {
  const { playback, ui } = store;
  const { ongoingSeek } = playback;
  const { width, seekThumbnail } = ui;

  return {
    ongoingSeek,
    width,
    seekThumbnail
  };
};

export default connect(selector)(SeekSprite);
